import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";

const PaymentReturn = () => {
    const [paymentResponse, setPaymentResponse] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [error, setError] = useState(true);
    const location = useLocation();
    const pathname = location.pathname;
    const orderId = pathname.split('/').pop();

    const onUpdatePaymentRes = useCallback(async () => {
        try {
            const response = await get(API_URL.UpdatePaymentResponse + `?OrderId=${orderId}`);
            if (response.isSuccess === 1) {
                if ((response.data.orderStatusId !== null) && (response.data.orderStatusId === 3 || response.data.orderStatusId === 5)) {
                    setPaymentResponse(response.data);
                }
            } 
        } catch (error) {
                setError("Please try again later.");
        }
    }, [orderId]);

    useEffect(() => {
        onUpdatePaymentRes();
        sessionStorage.removeItem('customReqId');
        const timer = setTimeout(() => {
            setShowLoader(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [onUpdatePaymentRes]);


    return (
        <div className="layout_main p-0">
            {showLoader ? (
                <div className="loader" >
                    <div className="spinner"></div>
                </div>
            )
                :
                (<div className="container ">
                    {paymentResponse.orderStatusId === 3 || paymentResponse.orderStatusId === 5 ? (
                        <div className='row'>
                            <div className="payment_successful text-center col-xl-5 col-md-6 col-sm-8 col-11">
                                <img src="../images/gif.gif" alt="Success GIF" className="success-gif" />
                                <h1>Order Placed Successfully!</h1>
                                <p>Thank you for your Order. Your Order has been Placed successfully.</p>
                                <p><b>OrderId:</b> {orderId}</p>
                                <div>
                                    <Link to='/' className="button web_buttons">Go to Homepage</Link>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='row'>
                            <div className="payment_successful payment_failed text-center col-xl-5 col-md-6 col-sm-8 col-11">
                                <img src="../images/failed.gif" alt="Success GIF" className="success-gif" />
                                <h1>Payment Failed!</h1>
                                <p>We couldn't process your payment. Please try again or contact support if the issue persists.</p>
                                <div>
                                    <Link to='/' className="button web_buttons">Go to Homepage</Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                )
            }

        </div >
    )
}

export default PaymentReturn;